import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  title: 'BONO 1 — 50 CLASES EXPRESS LISTAS PARA USAR',
  desc: 'Entrenamientos rápidos y dinámicos para cuando no tenés tiempo de planificar.',
  image: 'https://cdn.magicpatterns.com/uploads/6DMEUPNLTdJ9yXUeSYAX3M/image.png'
}, {
  title: 'BONO 2 — SISTEMA DE ROTACIÓN Y ARMADOS DE EQUIPO',
  desc: 'Cómo organizar grupos, rotaciones y partidos sin perder tiempo.',
  image: 'https://cdn.magicpatterns.com/uploads/5Cdn5VzjHAXQUffEFVh1Sg/image.png'
}, {
  title: 'BONO 3 — PLANILLAS PARA PROFESORES',
  desc: 'Asistencia, rendimiento y planificación en formato listo para imprimir o usar digital.',
  image: null
}, {
  title: 'BONO 4 — JUEGOS Y DINÁMICAS GRUPALES',
  desc: 'Actividades recreativas y competitivas para todas las edades.',
  image: 'https://cdn.magicpatterns.com/uploads/gjPCccEGezD94bShsmMsue/image.png'
}, {
  title: 'BONO 5 — MANUAL DE EMERGENCIAS DEL ENTRENADOR',
  desc: 'Cómo salvar entrenamientos improvisados, sin materiales o con poco espacio.',
  image: 'https://cdn.magicpatterns.com/uploads/w3duQHnr4xgYZYct9ZnGWX/image.png'
}, {
  title: 'BONO 6 — CALENDARIO ANUAL DEL PROFESOR',
  desc: 'Organización completa de temporada para no dejar nada al azar.',
  image: 'https://cdn.magicpatterns.com/uploads/bNkUsUKoRa7jiyKNghwBa6/image.png'
}, {
  title: 'BONO EXTRA — PSICOLOGÍA DEPORTIVA (BASE)',
  desc: 'Herramientas mentales para motivar, manejar la frustración y construir confianza en tus jugadores. SOLO POR COMPRAR HOY.',
  image: null,
  extra: true
}];
export function Bonuses() {
  return <section className="py-16 px-4 bg-blue-600 text-white" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-oswald font-bold uppercase mb-4" data-id="element-16">
            Ahorrá horas de estrés y hacé tus clases más eficientes
          </h2>
          <p className="text-xl font-medium text-blue-100" data-id="element-17">
            Llevate estos{' '}
            <span className="font-bold text-white underline decoration-2 underline-offset-4" data-id="element-18">
              6 BONOS GRATIS
            </span>{' '}
            + 1 BONO EXTRA por comprar hoy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-19">
          {bonuses.map((bono, index) => <div key={index} className={`bg-white text-slate-900 rounded-xl shadow-lg transform transition hover:-translate-y-1 overflow-hidden flex flex-col relative ${bono.extra ? 'border-2 border-yellow-300 ring-4 ring-blue-300/40 md:col-span-2 lg:col-span-3' : 'border-b-4 border-blue-800'}`} data-id="element-20">
              {bono.extra && <div className="absolute top-3 right-3 bg-blue-900 text-white text-xs font-bold uppercase px-3 py-1 rounded-full flex items-center gap-1 shadow" data-id="element-21">
                  <Sparkles className="w-3 h-3" data-id="element-22" />
                  Extra por hoy
                </div>}
              {bono.image && <div className="relative h-40 w-full overflow-hidden bg-blue-50" data-id="element-23">
                  <img src={bono.image} alt={bono.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-24" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/30 to-white" data-id="element-25"></div>
                </div>}
              <div className="p-6 flex-grow flex flex-col" data-id="element-26">
                <div className="flex items-center gap-3 mb-3" data-id="element-27">
                  <div className={`p-2 rounded-full flex-shrink-0 ${bono.extra ? 'bg-blue-900' : 'bg-blue-100'}`} data-id="element-28">
                    {bono.extra ? <Sparkles className="w-5 h-5 text-white" data-id="element-29" /> : <Gift className="w-5 h-5 text-blue-600" data-id="element-30" />}
                  </div>
                  <h3 className={`font-oswald font-bold leading-tight ${bono.extra ? 'text-xl text-blue-900' : 'text-lg'}`} data-id="element-31">
                    {bono.title}
                  </h3>
                </div>
                <p className="text-slate-600 font-medium" data-id="element-32">{bono.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}